import React from 'react';
import Layout from '../../components/Layout';
import CovidKidneyPage from '../../components/CovidKidneyPage';

import { TITLE } from '../../settings';

function action() {
  return {
    chunk: ['covid-kidney'],
    title: `${TITLE}: data-driven predictions of gene function and interactions`,
    component: (
      <Layout>
        <CovidKidneyPage />
      </Layout>
    ),
  };
}

export default action;
